if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          this.dispatchEvent(new CustomEvent("product-form--submitted",{detail:null,bubbles:true}));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('upsell-block-btn')){
  customElements.define('upsell-block-btn', class UpsellBlockBtn extends HTMLElement {
    constructor() {
      super();
      this.std_btn = this.querySelector('[data-drawer]');
      this.title_fw = this.querySelector('.accordion__title');
      this.init();
    }

    getActiveCurrencyCode(){
      const currencyMeta = document.querySelector('meta[property="og:price:currency"]');
      if (currencyMeta?.content) return currencyMeta.content;
      if (window.Shopify?.currency?.active) return window.Shopify.currency.active;
      return 'USD';
    }

    formatUpsellTotal(totalInCents){
      const totalInDollars = totalInCents / 100;
      const localeCode = document.documentElement.getAttribute('lang') || navigator.language || 'en-US';
      const currencyCode = this.getActiveCurrencyCode();
      const hasIntlNumberFormatter = typeof Intl !== 'undefined' && typeof Intl.NumberFormat === 'function';

      if (!hasIntlNumberFormatter) return `${currencyCode} ${totalInDollars.toFixed(2)}`;

      try {
        return new Intl.NumberFormat(localeCode, { style: 'currency', currency: currencyCode }).format(totalInDollars);
      } catch (error) {
        return `${currencyCode} ${totalInDollars.toFixed(2)}`;
      }
    }

    init(){
      this.std_btn.addEventListener('click', ()=> {
        const popup = document.querySelector(`#${this.std_btn.getAttribute('data-drawer')}`);        
        if(popup){
          document.body.classList.add('overflow-hidden');
          popup.classList.add('active');
        }
      });

      window.addEventListener('upsell:block:updated', (e)=>{
        if(e.detail.origin == this.std_btn.getAttribute('data-drawer')){
          if(e.detail.total > 0){
            const formattedUpsellTotal = this.formatUpsellTotal(e.detail.total);
            this.title_fw.innerHTML = `<span>${this.title_fw.dataset.title}</span> <span>+${formattedUpsellTotal}</span>`;
            return;
          }
          this.title_fw.innerHTML = this.title_fw.dataset.title;
        }
      })
    }
  })
}


if (!customElements.get('upsell-block')){
  customElements.define('upsell-block', class UpsellBlock extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      this.std_popup = this.querySelector('.drawer');
      this.std_apply = this.std_popup?.querySelector('.apply-changes');

      
      this.close_el = this.querySelectorAll('.cart-drawer__overlay, .drawer__close, .apply-changes, .back-btn');
      this.items = this.querySelectorAll('.cart-upsell__item');
      
      this.variants = [];
      this.total = 0;

      this.init()
      
    }
    init(){
      
      this.close_el.forEach(el => {
        el.addEventListener('click', ()=> {
          if(el.classList.contains('disabled')) return;
          document.body.classList.remove('overflow-hidden'); 
          el.closest('.drawer').classList.remove('active');
        });
      });
      this.items.forEach(item =>{
        item.addEventListener('click', (event)=>{
          if (event.target.closest('a')) return;
          item.classList.toggle('selected');
          this.updateCart(item);
          this.updateUi();
        })
      });
      
    }

    updateCart(item){
      if(item.classList.contains('selected')){
        this.variants.push({
          id: parseInt(item.dataset.id),
          price: parseFloat(item.dataset.price),
          type: item.dataset.type
        })
        return;
      }
      this.variants = this.variants.filter(sl => sl.id != parseInt(item.dataset.id));
    }
    
    getTotal(){
      this.total= 0
      this.variants.forEach(variant => {
        this.total += variant.price;
      })
    }

    getVariants(){
      return this.variants;
    }
    
    updateUi(){
      this.getTotal();

      if(this.std_apply){
        if (this.total > 0) {
          this.std_apply.classList.remove('disabled');
        }else{
          this.std_apply.classList.add('disabled');
        }
        event = new CustomEvent("upsell:block:updated", { detail: {total: this.total, origin: this.std_popup.getAttribute('id')}, bubbles:true});
        window.dispatchEvent(event);
      }

    }

    cleanUi(){
      this.variants = [];
      this.items.forEach(item => item.classList.remove('selected'));
    }

    submitCart(variants, upsellBlocks){
      if (variants.length < 1) return;
      const body = JSON.stringify({
          items: variants.map(item => {
            return {
              quantity: 1,
              id: item.id
            }
          }),
        sections: this.cart.getSectionsToRender().map((section) => section.id)
      });
      fetch(`${routes.cart_add_url}`, { ...{
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': `application/json` }
      }, body })
      .then((response) => response.json())
      .then((parsedState) => {
        if(this.cart) this.cart.renderContents(parsedState);
        upsellBlocks.forEach(upsell => {
          upsell.cleanUi();
          upsell.updateUi();
        });
      })
      .catch((e) => {
          console.error(e);
      })
    }

  })
}

document.addEventListener('product-form--submitted', ()=>{
  const upsellBlocks = Array.from(document.querySelectorAll('upsell-block'));
  const variants = [];
  upsellBlocks.forEach(upsell => {
    variants.push(...upsell.getVariants())
  });
  if(variants.length) upsellBlocks[0].submitCart(variants, upsellBlocks);
})
